import React, {PropTypes} from 'react';
import './notification.less';
import profileActions from '../../profile/profile_actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DashBoardHeader from '../../header_dashboard/dashboard_header';
import MediaQuery from 'react-responsive';
import CONSTANTS from '../../common_constants';
import authActions from '../../auth/auth_actions';
import {Link, browserHistory} from 'react-router';
import browsePackagesAction from '../../browse_packages/browser_packages_actions';
import moment from 'moment';

class NotificationDetail extends React.Component {
  constructor(props) {
    super(props);
  }
  selectNotification = (notification) =>{
    let eventId = notification.eventId;
    let userId = this.props.authState.userData.userId;
    this.props.readNotifications(notification.id);
    if(eventId == 2 || eventId == 5 || eventId == 6 || eventId == 20 || eventId == 21 || eventId == 22 || eventId == 41 || eventId == 44)
    {
      browserHistory.push("/shipment/"+ notification.shipmentId);
    }else if (eventId == 1 && notification.shipmentStatus===3) {
      browserHistory.push("/shipment-offers/"+ notification.shipmentId);
    }else if (eventId == 13 || eventId == 15 || eventId == 16 || eventId == 17 || eventId == 18 || eventId == 19 || eventId == 29 || eventId == 30 || eventId == 38 || eventId == 39 || eventId == 40) {
      browserHistory.push("/track-shipment/"+ notification.shipmentId);
    }else if ( eventId == 27 || eventId == 28) {
        // review modal box
    }
    else if (eventId == 14) {
      browserHistory.push("/inbox-chat/"+ notification.shipmentId +"/"+notification.carrierId + "?receiverId=" + notification.receiverId);
    }
    else if (eventId == 8 || eventId == 9 || eventId == 10 || eventId == 11) {
      browserHistory.push("/inbox-chat/"+ notification.shipmentId +"/"+notification.carrierId);
    }else if (eventId == 25) {
      browserHistory.push("/post-a-shipment/upload-photo?shipmentId=" + notification.shipmentId);
    }else if (eventId == 52) {
      this.props.browsePackagesAction.enableTrips();
      browserHistory.push('/browse-shipments');
    }
  }
  render() {
    const {notification} = this.props;
    const self = this;
    return (
      <div className = "notifications" onClick = {() => this.selectNotification(notification)}>
        <div className = "notification-header-wrap">
          <div className ={notification.isRead ? "status-notification read" : "status-notification un-read"}></div>
          <div className="notification-header">
            {notification.header}
          </div>
        </div>
        <div className="notification-content-wrap">
          <div className ="notification-content">
            {notification.message}
            <div className = "notification-date">{moment(notification.createTime).fromNow()}</div>
          </div>
          <div className="notification-delete">
              <span className="icon-cross-feather" onClick ={self.props.deleteNotification.bind(this,notification.id)}></span>
          </div>
        </div>
      </div>
    )
  }
}

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBubble : false
    }
  }
  componentDidMount(){
    this.setNotificationBubble();
  }
  componentWillReceiveProps(){
    this.setNotificationBubble()
  }
  readNotifications = (id) =>{
    let notificationIds = [] ;
    notificationIds.push(id)
    let paramObj ={
      notificationIds : notificationIds
    };
    this.props.profileActions.readNotification(paramObj).then((data)=>{

    },(errorRes)=>{
      if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({ajaxInProgress: false})
            this.props.authActions.sessionValid(false);
            cookies.delete('_sd');
            return ;
          }
        })
  }
  setNotificationBubble = ()=>{
    const notifications = this.props.profile.notifications.notifications;
    if(notifications)
    {
      for(let i=0;i< notifications.length;i++)
      {
          notifications[i].isRead == false
          this.setState({
            showBubble : true
          })
          break;
      }
    }
  }
  deleteNotification = (id ,e) =>{
    e.preventDefault();
    e.stopPropagation();
    let notificationIds = [] ;
    notificationIds.push(id)
    let paramObj ={
      notificationIds : notificationIds
    };
    this.props.profileActions.deleteNotification(paramObj).then((data)=>{
    },(errorRes)=>{
      if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({ajaxInProgress: false})
            this.props.authActions.sessionValid(false);
            cookies.delete('_sd');
            return ;
    }
    })
  }
  render() {
      const notifications = this.props.profile.notifications.notifications;
      const self = this;
      const {props, state} = this;
      let shipments = {};
      let sessionValid = true ;
      if("sessionValid" in props.authState.userData)
          sessionValid = props.authState.userData.sessionValid

      let user = {
        name: '',
        imageUrl: '',
        isVerified: ''
      };

      let isFirstTime;
      if(props.location)
         isFirstTime = props.location.query.isFirstTime;
      else
          isFirstTime = false;

      if(props.authState) {
        user.name = props.authState.userData.name;
        user.imageUrl = props.authState.userData.profileImageUrl;
        user.isVerified = props.authState.userData.isVerified;
      }
    return (
      <div className="notification-main-wrap">
      <MediaQuery query='(max-width: 767px)'>
      <DashBoardHeader user = {user} logout={this.logout}/>
      </MediaQuery>
      <div id="notifications-wrap">
          <MediaQuery query='(max-width: 767px)'>
            <div className = "notification-header-section">
              Notification
            </div>
          </MediaQuery>
          <div className="triangle"></div>
          <div className = "notification-div">
            {
              notifications && notifications.length > 0 && notifications.map((notification , index)=>{
                    return(
                      <NotificationDetail browsePackagesAction = {this.props.browsePackagesAction} authState = {this.props.authState}notification = {notification} key = {index} deleteNotification = {self.deleteNotification} readNotifications = {self.readNotifications}/>
                    )
              })
            }
            {
              !notifications && <div className = "no-notificaiton">No notifications found</div>
            }
            {
              notifications && notifications.length == 0 && <div className = "no-notificaiton">No notifications found</div>
            }
          </div>
      </div>
    </div>
    )
  }
}

Notification = connect((state) => {
    return {profile: state.app.profile,
    authState: state.app.auth}
}, (dispatch) => {
    return {
        profileActions: bindActionCreators(profileActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
    }
})(Notification);

export default Notification;



// WEBPACK FOOTER //
// app/components/notification/notification.jsx